import { CplData, Sweep } from "../apiClient/data-contracts";

export type Report = Sweep | CplData;

export enum ReportType {
  SWEEP = "sweep",
  CPL = "cpl",
}
